
<div class="modal-body p-4 text-white rounded consent-model">
    By continuing to use this website, you consent to the use of personal information in accordance with our
    <a class="text-white policy-link" href="https://www.trialassure.com/privacy-policy" target="_blank">Privacy Policy</a>
    <div class="d-flex justify-content-center pt-4">
        <button class="btn btn-light me-2 w-50 f-w-500" (click)="action(true)">Accept</button>
        <button class="btn btn-outline-light w-50 f-w-500" (click)="action(false)">Reject</button>
    </div>
</div>
